import UserCabinet from '../../components/UserCabinet';

function AccountSection({
    user,
    summary,
    summaryBusy,
    stats,
    onSave,
    onAvatarUpload,
    onCopy,
    openLightbox,
    busy,
    avatarBusy,
    showStatus,
    onProfileUpdate
}) {
    return (
        <UserCabinet
            user={user}
            summary={summary}
            summaryBusy={summaryBusy}
            stats={stats}
            onSave={onSave}
            onAvatarUpload={onAvatarUpload}
            onCopy={onCopy}
            openLightbox={openLightbox}
            busy={busy}
            avatarBusy={avatarBusy}
            showStatus={showStatus}
            onProfileUpdate={onProfileUpdate}
        />
    );
}

export default AccountSection;
